export default "__VITE_ASSET__Cs1p3Kyh__"